/**
 * Gestion des messages FR des pages d'erreurs
 */

module.exports = {

    default: {
        title: 'Oops !',
        subtitle: 'La page que vous recherchez semble être introuvable !',
        description: 'Il est probable que cette page ait été supprimé ou qu\'elle n\'ait jamais existé.',
        button: {
            home: {
                label: 'Retourner vers l\'accueil'
            },
            contact: {
                label: 'Nous contacter'
            }
        }
    },
    404: {
        title: 'Page introuvable',
        message: 'La page à laquelle vous essayez d\'accéder n\'existe pas ou a été déplacée.'
    }

};
